import { ParametrosPaginacao } from '../domain/primecap/model/interface/parametros-paginacao';

export const paginacao: ParametrosPaginacao = {
  tamanhoPagina: 10,
  indicePagina: 0
};
